import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import ButtonPrimary from "../styles/button-primary/button-primary.styles";
import {
  NavContainer,
  Logo,
  MenuItemsContainer,
  PaymentActions,
  CaptchaBackdrop,
  CaptchaDialog,
  CaptchaHeader,
  CaptchaCloseButton,
  CaptchaContainer
} from "./navbar.styles";

const RECAPTCHA_SITE_KEY = "6Lfa9IktAAAAAFuERXzz_mMEw4ZWkAYepOvGcTzp";

const Navbar = ({ screenSize }) => {
  const location = useLocation();
  const [showCaptcha, setShowCaptcha] = useState(false);
  const paymentForm = useRef(null);
  const captchaElement = useRef(null);
  const captchaWidgetId = useRef(null);

  useEffect(() => {
    if (!showCaptcha) {
      return undefined;
    }

    let renderTimer;

    const renderCaptcha = () => {
      if (!window.grecaptcha || !window.grecaptcha.render || !captchaElement.current) {
        renderTimer = window.setTimeout(renderCaptcha, 100);
        return;
      }

      captchaWidgetId.current = window.grecaptcha.render(captchaElement.current, {
        sitekey: RECAPTCHA_SITE_KEY,
        callback: () => paymentForm.current.submit(),
        "expired-callback": () => window.grecaptcha.reset(captchaWidgetId.current)
      });
    };

    renderCaptcha();

    return () => {
      window.clearTimeout(renderTimer);
      captchaWidgetId.current = null;
    };
  }, [showCaptcha]);

  const closeCaptcha = () => {
    if (window.grecaptcha && captchaWidgetId.current !== null) {
      window.grecaptcha.reset(captchaWidgetId.current);
    }
    setShowCaptcha(false);
  };

  return (
    <NavContainer>
      <Logo href="/">
        <img src={logo} alt="logo" />
      </Logo>
      {location.pathname !== "/" && (
        <MenuItemsContainer>
          <PaymentActions>
            <form
              ref={paymentForm}
              method="post"
              action="https://Simplecheckout.authorize.net/payment/CatalogPayment.aspx"
            >
              <input
                type="hidden"
                name="LinkId"
                data-test="17-08-026"
                value="1b4c0e11-01f2-47e2-b7d3-c7288c43276b"
              />
              <ButtonPrimary type="button" width="150px" onClick={() => setShowCaptcha(true)}>
                Make a Payment
              </ButtonPrimary>
            </form>
            {screenSize.width >= 700 && (
              <Link to="/">
                <ButtonPrimary type="button">Logout</ButtonPrimary>
              </Link>
            )}
          </PaymentActions>
        </MenuItemsContainer>
      )}
      {showCaptcha && (
        <CaptchaBackdrop role="presentation" onMouseDown={closeCaptcha}>
          <CaptchaDialog
            role="dialog"
            aria-modal="true"
            aria-labelledby="captcha-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <CaptchaHeader>
              <h4 id="captcha-title">Security verification</h4>
              <CaptchaCloseButton type="button" onClick={closeCaptcha} aria-label="Close">
                &times;
              </CaptchaCloseButton>
            </CaptchaHeader>
            <p>Please confirm you are not a robot to continue to payment.</p>
            <CaptchaContainer ref={captchaElement} />
          </CaptchaDialog>
        </CaptchaBackdrop>
      )}
    </NavContainer>
  );
};

export default Navbar;
